export default [
  {
    path: "/digital-running-companion",
    name: "数字化方案陪跑|以BLM绩效飞轮®为基础，辅以专家落地指导。",
    component: () =>
      import("@/views/digitalization/digital-running-companion.vue"),
    meta: {
      title: "数字化方案与陪跑"
    }
  },
  {
    path: "/epm",
    name:
      "EPM企业绩效系统|以绩效飞轮®为底座的EPM，绩效管理、基础人事、主线作业流程、经营性财务、KM与ELN、CRM（销售管理）",
    component: () => import("@/views/digitalization/epm.vue"),
    meta: {
      title: "EPM企业绩效系统"
    }
  },
  {
    path: "/performance-flywheel",
    name: "绩效飞轮|让战略成为每个人的日常工作",
    component: () => import("@/views/digitalization/performance-flywheel.vue"),
    meta: {
      title: "绩效飞轮"
    }
  },
  {
    path: "/elp",
    name: "ELP|大企业在线学习平台,助力企业建立自己的企业商学院",
    component: () => import("@/views/digitalization/elp.vue"),
    meta: {
      title: "ELP云学习生态平台"
    }
  },
  {
    path: "/weixue",
    name:
      "微学|学、考、练、用、培训数字化管理、学习运营与管理、海量课程库、数据化反馈、内部知识沉淀",
    component: () => import("@/views/digitalization/weixue.vue"),
    meta: {
      title: "微学"
    }
  },
  {
    path: "/guanghua",
    name:
      "光华商学|个人及企业学习小组移动学习平台，九大学堂、350+门课程 4700+小节、满足各种个人及企业学习小组的学习需求",
    component: () => import("@/views/digitalization/guanghua.vue"),
    meta: {
      title: "光华商学"
    }
  }
];
